import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../../@fury/shared/material-components.module';
import { LayoutComponent } from './layout.component';
import { SidenavModule } from './sidenav/sidenav.module';
import { ToolbarModule } from './toolbar/toolbar.module';
import { FurySharedModule } from '../../@fury/fury-shared.module';
import { LoadingOverlayModule } from '../../@fury/shared/loading-overlay/loading-overlay.module';
import { FuryAlertBoxModule } from '../../@fury/shared/alert-box/alert-box.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FurySharedModule,

    // Core
    ToolbarModule,
    SidenavModule,
    LoadingOverlayModule,
    FuryAlertBoxModule,
  ],
  declarations: [LayoutComponent]
})
export class LayoutModule {
}
